import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Mail, ArrowLeft, Sparkles } from 'lucide-react';
import { toast } from 'sonner';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSubmitted(true);
      toast.success('If the email exists, a reset link has been sent.');
    } catch (err) {
      toast.error('Failed to send reset link.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <Sparkles className="h-10 w-10 text-gold" />
            <span className="text-2xl font-bold text-navy">ProcureOne Ultra</span>
          </div>
          <h1 className="text-2xl font-semibold text-navy">Reset Password</h1>
          <p className="text-muted-foreground mt-2">Enter your email to receive a reset link</p>
        </div>

        <div className="bg-card border border-border rounded-lg p-8 shadow-lg">
          {!submitted ? (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium mb-2">Email</label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="w-full pl-10 pr-4 py-2 rounded-md border border-input bg-background"
                    placeholder="you@example.com"
                    data-testid="forgot-email-input"
                  />
                </div>
              </div>
              <button type="submit" disabled={loading} className="w-full px-6 py-3 rounded-md bg-navy text-white font-semibold" data-testid="forgot-submit-btn">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          ) : (
            <div className="text-center py-8">
              <Mail className="h-16 w-16 mx-auto mb-4 text-gold" />
              <h2 className="text-xl font-semibold mb-2 text-navy">Check Your Email</h2>
              <p className="text-muted-foreground">If an account exists with this email, we have sent password reset instructions.</p>
            </div>
          )}

          <Link to="/login" className="mt-6 flex items-center justify-center text-sm text-navy hover:underline" data-testid="back-to-login-link">
            <ArrowLeft className="h-4 w-4 mr-1" /> Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
